import React from 'react';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { formatDateInTimezone } from '../../utils/dateUtils';

const PublishModal = ({ 
    show, 
    onHide, 
    onConfirm, 
    campaign 
}) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Campaign Publication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {campaign && (
                    <>
                        <h5>Campaign: {campaign.campaign_name}</h5>
                        <div className="mb-4">
                            <h6>Start Date:</h6>
                            <ul className="list-unstyled">
                                <li><strong style={{color: 'red'}}>UTC: {formatDateInTimezone(campaign.campaign_start_date, 'UTC')}</strong></li>
                                <li><strong>Browser Time:</strong> {formatDateInTimezone(campaign.campaign_start_date, Intl.DateTimeFormat().resolvedOptions().timeZone)}</li>
                                <li><strong>Swiss Time:</strong> {formatDateInTimezone(campaign.campaign_start_date, 'Europe/Zurich')}</li>
                            </ul>
                        </div>
                        <div className="mb-4">
                            <h6>End Date:</h6>
                            <ul className="list-unstyled">
                                <li><strong style={{color: 'red'}}>UTC: {formatDateInTimezone(campaign.campaign_end_date, 'UTC', true)}</strong></li>
                                <li><strong>Browser Time:</strong> {formatDateInTimezone(campaign.campaign_end_date, Intl.DateTimeFormat().resolvedOptions().timeZone)}</li>
                                <li><strong>Swiss Time:</strong> {formatDateInTimezone(campaign.campaign_end_date, 'Europe/Zurich')}</li>
                            </ul>
                        </div>
                        {campaign.campaign_budget && (
                            <div>
                                <h6>Budget:</h6>
                                <p>{campaign.campaign_budget.amount} (per {campaign.campaign_budget.periodicity} {campaign.campaign_budget.periodicity_unit})</p>
                                <p>Strategy: {campaign.campaign_budget.allocation_strategy}</p>
                            </div>
                        )}
                        {campaign.campaign_display_groups && (
                            <div>
                                <h6>Display Groups:</h6>
                                <p>{campaign.campaign_display_groups.length} group(s) configured</p>
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm}>
                    Confirm & Publish
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PublishModal; 